import React from "react";
import withIconComponent from "../withIconComponent";

var ChevronDown = function ChevronDown() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M16 10l-4 4-4-4",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  });
};

export default withIconComponent("UiChevronDown", false)(ChevronDown);